import { render } from "./Layout.vue?vue&type=template&id=78bf5b02"
import script from "./Layout.vue?vue&type=script&lang=js"
export * from "./Layout.vue?vue&type=script&lang=js"

import "./Layout.vue?vue&type=style&index=0&id=78bf5b02&lang=scss"
script.render = render

export default script